import { IBalance } from "@/core/models/balance.model";
import { IHMI } from "@/core/models/hmi.model";
import { IUser } from "@/core/models/user.model";
import moment from "jalali-moment";

export const DEFAULT_USER: IUser = {
  hasPanelAccess: true,
  isAuthenticated: false,
  personalId: 0,
  firstname: "",
  lastname: "",
  phoneNumber: "",
  workSchedule: "day",
};

export const DEFAULT_BALANCE: IBalance = {
  result: {
    composition: {
      co: {},
      co2: {},
      h2: {},
      h2o: {},
      n2: {},
      ch4: {},
      c2h6: {},
      c3h8: {},
      c4h10: {},
      c5h12: {},
      c6h14: {},
      o2: {},
      flow: {},
      temp: {},
    },
    product: [],
    reformer: {
      reaction_heat_to_tubes: 0,
      reformer_heat_losses: 0,
      sensible_heat_to_tubes: 0,
      total_heat_released_by_fuel: 0,
    },
    recuperator: {
      cold_air_bundle: 0,
      feed_gas: 0,
      hot_air_bundle: 0,
      lost_to_seal: 0,
      lost_to_stack: 0,
      total_recovered: 0,
    },
  },
  history: [],
};

export const DEFAULT_HMI: IHMI = {
  paramsResponse: [],
  params: {
    AIT_X118: { id: 1, value: 0, min: 0, max: 0, enable: true },
    AIT_X131_1: { id: 2, value: 0, min: 0, max: 0, enable: true },
    AIT_X131_2: { id: 3, value: 0, min: 0, max: 0, enable: true },
    AIT_X132_1: { id: 4, value: 0, min: 0, max: 0, enable: true },
    AIT_X132_2: { id: 5, value: 0, min: 0, max: 0, enable: true },
    AIT_X133_1: { id: 6, value: 0, min: 0, max: 0, enable: true },
    AIT_X133_2: { id: 7, value: 0, min: 0, max: 0, enable: true },
    AIT_X137: { id: 8, value: 0, min: 0, max: 0, enable: true },
    AIT_X176: { id: 9, value: 0, min: 0, max: 0, enable: true },
    AIT_X418_1: { id: 10, value: 0, min: 0, max: 0, enable: true },
    AIT_X728: { id: 11, value: 0, min: 0, max: 0, enable: true },
    FT_X120_1: { id: 12, value: 0, min: 0, max: 0, enable: true },
    FT_X120_2: { id: 13, value: 0, min: 0, max: 0, enable: true },
    FT_X122: { id: 14, value: 0, min: 0, max: 0, enable: true },
    FT_X133: { id: 15, value: 0, min: 0, max: 0, enable: true },
    FT_X136: { id: 16, value: 0, min: 0, max: 0, enable: true },
    FT_X169: { id: 17, value: 0, min: 0, max: 0, enable: true },
    FT_X171: { id: 18, value: 0, min: 0, max: 0, enable: true },
    FT_X172: { id: 19, value: 0, min: 0, max: 0, enable: true },
    FT_X178: { id: 20, value: 0, min: 0, max: 0, enable: true },
    FT_X206_1: { id: 21, value: 0, min: 0, max: 0, enable: true },
    FT_X206_2: { id: 22, value: 0, min: 0, max: 0, enable: true },
    FT_X207: { id: 23, value: 0, min: 0, max: 0, enable: true },
    FT_X211: { id: 24, value: 0, min: 0, max: 0, enable: true },
    FT_X516: { id: 25, value: 0, min: 0, max: 0, enable: true },
    FT_X517: { id: 26, value: 0, min: 0, max: 0, enable: true },
    FT_X519: { id: 27, value: 0, min: 0, max: 0, enable: true },
    FT_X728_1: { id: 28, value: 0, min: 0, max: 0, enable: true },
    FT_X901: { id: 29, value: 0, min: 0, max: 0, enable: true },
    PT_X119: { id: 30, value: 0, min: 0, max: 0, enable: true },
    PT_X208_1: { id: 31, value: 0, min: 0, max: 0, enable: true },
    PT_X208_2: { id: 32, value: 0, min: 0, max: 0, enable: true },
    PT_X270: { id: 33, value: 0, min: 0, max: 0, enable: true },
    PT_X144: { id: 34, value: 0, min: 0, max: 0, enable: true },
    FT_X560: { id: 35, value: 0, min: 0, max: 0, enable: true },
    PT_X145: { id: 36, value: 0, min: 0, max: 0, enable: true },
    PT_X307_1: { id: 37, value: 0, min: 0, max: 0, enable: true },
    PT_X307_2: { id: 38, value: 0, min: 0, max: 0, enable: true },
    PT_X728: { id: 39, value: 0, min: 0, max: 0, enable: true },
    PT_X749: { id: 40, value: 0, min: 0, max: 0, enable: true },
    TT_X119: { id: 41, value: 0, min: 0, max: 0, enable: true },
    TT_X125_1: { id: 42, value: 0, min: 0, max: 0, enable: true },
    TT_X125_2: { id: 43, value: 0, min: 0, max: 0, enable: true },
    TT_X134_1: { id: 44, value: 0, min: 0, max: 0, enable: true },
    TT_X134_2: { id: 45, value: 0, min: 0, max: 0, enable: true },
    TT_X135: { id: 46, value: 0, min: 0, max: 0, enable: true },
    TT_X152_1: { id: 47, value: 0, min: 0, max: 0, enable: true },
    TT_X152_2: { id: 48, value: 0, min: 0, max: 0, enable: true },
    TT_X152_3: { id: 49, value: 0, min: 0, max: 0, enable: true },
    TT_X152_4: { id: 50, value: 0, min: 0, max: 0, enable: true },
    TT_X152_5: { id: 51, value: 0, min: 0, max: 0, enable: true },
    TT_X152_6: { id: 52, value: 0, min: 0, max: 0, enable: true },
    TT_X152_7: { id: 53, value: 0, min: 0, max: 0, enable: true },
    TT_X152_8: { id: 54, value: 0, min: 0, max: 0, enable: true },
    TT_X152_9: { id: 55, value: 0, min: 0, max: 0, enable: true },
    TT_X152_10: { id: 56, value: 0, min: 0, max: 0, enable: true },
    TT_X170: { id: 57, value: 0, min: 0, max: 0, enable: true },
    TT_X170_1: { id: 58, value: 0, min: 0, max: 0, enable: true },
    TT_X170_2: { id: 59, value: 0, min: 0, max: 0, enable: true },
    TT_X186: { id: 60, value: 0, min: 0, max: 0, enable: true },
    TT_X221_1: { id: 61, value: 0, min: 0, max: 0, enable: true },
    TT_X222_1: { id: 62, value: 0, min: 0, max: 0, enable: true },
    TT_X222_2: { id: 63, value: 0, min: 0, max: 0, enable: true },
    TT_X302_1: { id: 64, value: 0, min: 0, max: 0, enable: true },
    TT_X306_2: { id: 65, value: 0, min: 0, max: 0, enable: true },
    TT_X317_5: { id: 66, value: 0, min: 0, max: 0, enable: true },
  },
  predictionResult: {},
  HMIChart: {
    config: {
      parameter: "carbon",
      from: new Date(
        moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss")
      ),
      to: new Date(moment().add(1, "days").format("YYYY-MM-DD HH:mm:ss")),
    },
    data: {
      3: [],
      5: [],
      8: [],
      lab: [],
    },
  },
  predictionHistory: [],
  recommendationResult: {},
  recommendationHistory: [],
};
